import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ImageAdd } from 'blaze-ui/icons'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, track } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'
import { Pressable } from '@react-aria/interactions'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { MaskShapeUtil } from 'components/VisualStudioPlayground/Shapes/MaskShape/MaskShapeUtil'
import { VideoShape } from 'components/VisualStudioPlayground/Shapes/VideoShape/Types'
import { VideoShapeUtil } from 'components/VisualStudioPlayground/Shapes/VideoShape/VideoShapeUtil'

interface Props {
  editor: Editor
  shape: ImageShape | MaskShape | VideoShape
}

export const Replaceable = track(({ editor, shape }: Props) => {
  const isReplaceable = shape.props.isReplaceable

  const toggleReplaceable = () => {
    if (shape.type === 'mask') {
      const shapeUtil = editor.getShapeUtil(shape) as MaskShapeUtil
      shapeUtil.setReplaceable(shape, !isReplaceable)
      return
    }
    if (shape.type === 'image') {
      const shapeUtil = editor.getShapeUtil(shape) as ImageShapeUtil
      shapeUtil.setReplaceable(shape, !isReplaceable)
    }
    if (shape.type === 'video') {
      const shapeUtil = editor.getShapeUtil(shape) as VideoShapeUtil
      shapeUtil.setReplaceable(shape, !isReplaceable)
    }
  }

  return (
    <div className={Styles.colorSection}>
      <Pressable onPress={() => toggleReplaceable()}>
        <div className={Styles.actionRow}>
          <ImageAdd color="var(--selected-fill)" />
          <span className={Styles.actionName}>
            <Text variant="smallList">Replaceable</Text>
          </span>
          <ToggleButton name="replaceable" size="sm-md" checked={isReplaceable} handleChange={() => {}} />
        </div>
      </Pressable>
    </div>
  )
})
